export const MINUTES_IN_DAY = 1440;
export const MILLISECONDS_IN_DAY = 86400000;
export const NUMBER_OF_DAYS_IN_WEEK = 7;
